import { useState, useEffect } from 'react';
/* datas */
import { HostBackend } from '../../../../Routes/HostBackend.js';
/* document */
import { Select } from '../../Form/Inputs/Select.js';
import { Text } from '../../Form/Inputs/Text.js';
import { Date } from '../../Form/Inputs/Date.js';
import { Hidden } from '../../Form/Inputs/Hidden.js';

export const Origin = (props) => {
    const { el } = props;
    const backend = HostBackend();
    const token = sessionStorage.getItem('token');
    const [choosers, setChoosers] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasChoosers = await fetch(`${backend}/admin/choosers/origin`, {
                method: 'GET', headers: { 'Authorization': token, 'Content-Type': 'application/json' }
            });
            const choosers = await datasChoosers.json();
            setChoosers(choosers);
        };
        fetchData();
    }, [backend, token]);
    return (
        <>
            <Text name="name" value={el ? el.name : ''} />
            <Text name="slug" value={el ? el.slug : ''} />
            <Date name="created" value={el ? el.created :''} />
            <Text name="author" value={el ? el.author : ''} />
            <Text name="number" value={el ? el.number : ''} />
            <Select name="id_type" choosers={choosers.type} value={el ? el.id_type : ''} />
            <Text name="route" value={el ? el.route : ''} />
            <Select name="id_description" choosers={choosers.describe} value={el ? el.id_description : ''} />
            <Hidden name="id" value={el ? el.id : ''} />
        </>
    )
}